import { Input } from 'antd';
import { useEffect, useState } from 'react'

EditableInput = ({ initialValue, save, inputValidator=((e)-> e.target.value), props... }) ->

  [loading, setLoading] = useState(false)
  [value, setValue] = useState(initialValue)

  useEffect(->
    setValue(initialValue)
  , [initialValue])

  <Input
    allowClear
    value={value}
    disabled={loading}
    {props...}
  />

export default EditableInput
